// eslint-disable-next-line import/prefer-default-export
export function registerComponent(component) {
  // 这里必须要T extends Component，否则生成的.d.ts文件不能返回正确组件类型，导致在业务中引入组件时候，tsx不能正常使用
  component.install = app => {
    app.component(component.name || '', component);
    return app;
  };
  return component;
}
export const commonProps = {
  class: {
    type: String
  },
  style: {}
};